import axiosServices from './interceptor';

const BASE = '/trip-management';

// ── Dashboard ──────────────────────────────────────────────────────────────
export const fetchManagerKPIs      = ()           => axiosServices.get(`${BASE}/dashboard/kpis`);
export const fetchExecutiveKPIs    = ()           => axiosServices.get(`${BASE}/dashboard/executive-kpis`);

// ── Trips ──────────────────────────────────────────────────────────────────
export const fetchAllTrips         = (params)     => axiosServices.get(`${BASE}/trips`, { params });
export const fetchTripById         = (id)         => axiosServices.get(`${BASE}/${id}`);
export const fetchRunningTrips     = ()           => axiosServices.get(`${BASE}/running`);
export const deleteTrip            = (id)         => axiosServices.delete(`${BASE}/trips/${id}`);

// ── Assignment ─────────────────────────────────────────────────────────────
export const assignTrip            = (id, data)   => axiosServices.put(`${BASE}/${id}/assign`, data);
export const bulkAssignTrips       = (data)       => axiosServices.post(`${BASE}/bulk-assign`, data);
export const fetchExecutiveWorkload= ()           => axiosServices.get(`${BASE}/executives/workload`);

// ── Trip Updates ───────────────────────────────────────────────────────────
export const updateTripStatus      = (id, status) => axiosServices.put(`${BASE}/${id}/status`, { status });
export const updateConfirmations   = (id, data)   => axiosServices.put(`${BASE}/${id}/confirmations`, data);
export const updateChecklist       = (id, data)   => axiosServices.put(`${BASE}/${id}/checklist`, data);
export const addChecklistItem      = (id, data)   => axiosServices.post(`${BASE}/${id}/checklist/add`, data);
export const addNote               = (id, data)   => axiosServices.post(`${BASE}/${id}/notes`, data);
export const updateGuestFeedback   = (id, data)   => axiosServices.put(`${BASE}/${id}/feedback`, data);

// ── Escalations ────────────────────────────────────────────────────────────
export const raiseEscalation       = (id, data)   => axiosServices.post(`${BASE}/${id}/escalations`, data);
export const resolveEscalation     = (id, escId, data) => axiosServices.put(`${BASE}/${id}/escalations/${escId}/resolve`, data);

// ── Payment ────────────────────────────────────────────────────────────────
export const fetchPaymentDashboard = (view)       => axiosServices.get(`${BASE}/payments`, { params: { view } });
export const addCollectionNote     = (id, data)   => axiosServices.post(`${BASE}/${id}/payment/collect`, data);

// ── Calendar ───────────────────────────────────────────────────────────────
export const fetchCalendarEvents   = (start, end) => axiosServices.get(`${BASE}/calendar`, { params: { start, end } });

// ── Activities ─────────────────────────────────────────────────────────────
export const fetchTripActivities   = (id)         => axiosServices.get(`${BASE}/${id}/activities`);

// ── Reminders ──────────────────────────────────────────────────────────────
export const fetchReminders        = ()           => axiosServices.get(`${BASE}/reminders`);
